import React, { useEffect, useState, useRef } from 'react';
import { Copy } from 'lucide-react';
import PlaceOutbondCall from './PlaceOutbondCall';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';
import { updateAssistant } from '../../utils/api/assistantAPI'; // make sure this API is correctly imported
import { useDispatch } from 'react-redux';
import { fetchAssistantDetail } from '../../store/app/assistantSlice';
import CampaignModel from '../child/CampaignModel';

function HeaderComponent() {
    const [showCallModal, setShowCallModal] = useState(false);
    const activeDetails = useSelector((state) => state.assistants.activeDetail || {});
    const [agent, setAgent] = useState(activeDetails?.details?.name || '');
    const editableRef = useRef(null);
    const debounceTimeout = useRef(null);
    const prevAgentName = useRef(agent);
    const dispatch = useDispatch();
    const [campaignModel, setCampaignModel] = useState(false);
    

    useEffect(() => {
        setAgent(activeDetails?.details?.name || '');
        prevAgentName.current = activeDetails?.details?.name || '';
    }, [activeDetails?.details?.name,]);

    useEffect(() => {
        if (editableRef.current && editableRef.current.textContent !== agent) {
            editableRef.current.textContent = agent;
        }
    }, [agent]);

    const handleCopy = () => {
        navigator.clipboard.writeText(activeDetails?.assistant?.id).then(() => {
            toast.success("Assistant ID copied to clipboard");
        }).catch(err => {
            console.error("Copy failed:", err);
        });
    };

    const handleDebouncedUpdate = (newName) => {
        if (!activeDetails?.assistant?.id || newName === prevAgentName.current) return;

        updateAssistant(activeDetails.assistant.id, { name: newName })
            .then(() => {
                toast.success("Assistant name updated");
                prevAgentName.current = newName;

                dispatch(fetchAssistantDetail(activeDetails.assistant.id));

                // page reload after update
                window.location.reload();
            })
            .catch((err) => {
                toast.error("Failed to update agent name");
                console.error("API update error:", err);
            });

    };



    const handleAgentNameChange = (newName) => {
        setAgent(newName);

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            handleDebouncedUpdate(newName);
        }, 1000);
    };

    return (
        <div className='card m-10'>
            <header className="agent-header">
                <div className="agent-header-left">
                    {/* Editable agent name */}
                    <div
                        ref={editableRef}
                        contentEditable
                        suppressContentEditableWarning={true}
                        onInput={(e) => handleAgentNameChange(e.currentTarget.textContent)}
                        style={{
                            padding: '8px 12px',
                            borderBottom: '1px solid #e0e0e0',
                            borderRadius: '6px',
                            minWidth: '150px',
                            outline: 'none',
                            cursor: 'text'
                        }}
                    />

                    {/* Copy Button */}
                    <button
                        onClick={handleCopy}
                        title="Copy"
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px'
                        }}
                    >
                        <Copy size={18} />
                    </button>

                    <div className="agent-header-selects">
                        {/* Optional dropdowns for language and voice */}
                    </div>
                </div>

                <div className="agent-header-right">
                    <button
                        type="button"
                        className="btn btn-primary-600 radius-8 px-14 py-6 text-sm"
                        onClick={() => setShowCallModal(true)}
                    >
                        Get call from agent
                    </button>

                    <button
                        type="button"
                        className="btn agent-btn-outline radius-8 px-14 py-6 text-sm"
                        onClick={() => setCampaignModel(true)}
                    >
                        Start Campaign
                    </button>

                    {/* <Link to="/phone-number">
                        <button type="button" className="agent-link-btn">
                            Request phone numbers ↗
                        </button>
                    </Link> */}
                </div>
            </header>

            {/* Optional Cost Overview */}
            {/* <div className="agent-cost-overview-section">... </div> */}

            {showCallModal && (
                <PlaceOutbondCall
                    activeAssistantId={activeDetails?.assistant?.id}
                    onClose={() => setShowCallModal(false)}
                />
            )}
            {
                campaignModel && (
                    <CampaignModel setShowCampaignModal={() => setCampaignModel(false)}/>
                )
            }
        </div>
    );
}

export default HeaderComponent;
